import { useState } from "react";
import { useNavigate } from 'react-router-dom';

/* CSS */
import AuthHeader from '../components/layout/AuthHeader';
import shared from '../styles/shared.module.css';
import styles from "./LoginPage.module.css";

/* Authentication component */
import PasswordInput from "../components/auth/PasswordInput";
import OAuth from "../components/auth/OAuth";

/* Context */
import { useAuthContext } from "../context/AuthContext";

/* API helper */
import { api } from "../api";

/* Icons */
import exclamation from '../assets/icons/exclamation_red.svg'

const LoginPage = () => {

    const navigate = useNavigate();

    const { login } = useAuthContext();

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [loginError, setLoginError] = useState("");

    const handleLogin = async () => {
        try {
            setIsLoading(true);
            // Do we need to do a browser-validation if there are too many API requests in the future?
            const data = await api.post('/auth/login', { email, password });
            login(data.token, data.user);
            console.log("Success! Token: ", data.token);
            navigate('/');
        } catch (err) {
            console.error("Error loging you in: ", err);
            // Keep a generic message on purpose — don't reveal whether the email exists.
            setLoginError("Invalid email or password.");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            {/* Header */}
            <AuthHeader showCancel={false} />

            {/* Body */}
            <div className={shared.authBody}>
                {/* Greetings title */}
                <div className={shared.authTitleWrapper}>
                    <div className={shared.authTitle}>
                        Welcome back!
                    </div>
                    <div className={shared.authSubtitleWrapper}>
                        <div className={shared.authSubTitleText}>
                            New to TravelBuddy?
                        </div>
                        <div
                            className={shared.authSubTitleToggle}
                            onClick={() => navigate('/signup')}
                        >
                            Sign up
                        </div>
                    </div>
                </div>

                {/* Main input */}
                <div className={shared.authBodyInput}>

                    <form noValidate onSubmit={(e) => { e.preventDefault(); handleLogin(); }}>
                        {/* Email */}
                        <div className={shared.authField}>
                            <div className={shared.authFieldLabel}>
                                Email address
                            </div>

                            <input
                                type="email"
                                name="email"
                                autoComplete="email"
                                className={shared.authFieldInput}
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                        </div>

                        {/* Password */}
                        <div className={shared.authField}>
                            <PasswordInput
                                label={"Password"}
                                value={password}
                                onChange={setPassword}
                                containerStyle={{ width: '100%' }}
                            />
                        </div>

                        {/* Login error */}
                        {loginError &&
                            <div className={styles.loginError}>
                                <img
                                    src={exclamation}
                                    alt="Invalid email or password"
                                    className={styles.loginErrorIcon}
                                />
                                <div className={styles.loginErrorMessage}>
                                    {loginError}
                                </div>
                            </div>
                        }

                        {/* Login button */}
                        <button
                            type="submit"
                            className={`${shared.authButton} ${isLoading ? shared.buttonLoading : ''}`}
                        >
                            <div className={shared.buttonContent}>
                                {isLoading ? "Just a sec..." : "Login"}
                                {isLoading && <span className={shared.spinner}></span>}
                            </div>
                        </button>
                    </form>

                    <div
                        className={styles.trouble}
                        onClick={() => navigate('/forgotpassword')}
                    >
                        Forgot your password?
                    </div>

                    {/* OAuth */}
                    <OAuth dividerText={"Or log in with"} />
                </div>
            </div>
        </>
    );
};

export default LoginPage;